module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors-refine/img_collaborate01-92fcf6c269b4a23302322b78eb953ce0.png";